import React, { useEffect, useState } from 'react';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';
import { Summary } from './Summary';
import { isAuthenticated } from '../../helpers';

export const SummaryContainer = ({ ...props }) => {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    setAuthenticated(isAuthenticated());
  }, []);

  return (
    <QueryProvider
      defaultVariables={{}}
      cacheKey={`list-summary-page-${ authenticated ? 'user' : 'guest'}`}
    >
      <Summary authenticated={authenticated} />
    </QueryProvider>
  );
};

SummaryContainer.dataModel = extend(Summary);

SummaryContainer.propTypes = {
};

SummaryContainer.defaultProps = {
};
